
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25.1 2.57a22.5 22.5 0 0 1 8.77 1.77A22.7 22.7 0 0 1 41 9.17a22.7 22.7 0 0 1 4.83 7.17 22.64 22.64 0 0 1 0 17.55 23 23 0 0 1-2.08 3.82A22.6 22.6 0 0 1 41 41.05a23 23 0 0 1-3.3 2.75 22.59 22.59 0 0 1-21.38 2.08 22.5 22.5 0 0 1-7.16-4.83 22.7 22.7 0 0 1-2.76-3.34 22.58 22.58 0 0 1 0-25.2 22.8 22.8 0 0 1 6.09-6.09 23.7 23.7 0 0 1 3.83-2.08 22.5 22.5 0 0 1 8.78-1.77m0-1.44a24 24 0 1 0 24 24 24 24 0 0 0-24-24","fill":"#32373c"}}),_c('path',{attrs:{"d":"M5.11 25.11a20 20 0 0 0 11.27 18L6.84 17a19.85 19.85 0 0 0-1.73 8.11m33.48-1a10.5 10.5 0 0 0-1.65-5.51c-1-1.64-2-3-2-4.68a3.46 3.46 0 0 1 3.35-3.55h.26A20 20 0 0 0 8.4 14.14h1.29c2.09 0 5.32-.25 5.32-.25a.82.82 0 0 1 .13 1.64s-1.08.13-2.29.19l7.28 21.65 4.37-13.1-3.11-8.53c-1.08-.06-2.1-.19-2.1-.19a.82.82 0 0 1 .13-1.64s3.3.25 5.26.25 5.32-.25 5.32-.25a.82.82 0 0 1 .13 1.64s-1.09.13-2.29.19l7.22 21.48 2.06-6.53a23 23 0 0 0 1.47-6.59Zm-13.14 2.75-6 17.42A19.86 19.86 0 0 0 31.73 44a2 2 0 0 1-.14-.27Zm17.18-11.33a14.5 14.5 0 0 1 .14 2 18.9 18.9 0 0 1-1.52 7.16l-6.11 17.69a20 20 0 0 0 7.49-26.85","fill":"#32373c"}})])
          )
        }
      }
    